import { FLOOR_NAMES, type FloorId } from '@/world/types';

/** Keep the floor once while preserving references to a different destination floor. */
export function locationLabel(floor: FloorId, room: string): string {
  const name = FLOOR_NAMES[floor], prefix = name + ' ';
  return `${name} · ${room.startsWith(prefix) ? room.slice(prefix.length) : room}`;
}

/** All user-facing strings (Korean). */
export const T = {
  title: '홈홈홈',
  subtitle: '친구를 데리고 저택에서 탈출하라',
  pressAny: '아무 키나 누르세요',
  newGame: '새로 시작',
  continueGame: '이어하기',
  howTo: '조작법',
  developer: '마루하루게임즈',
  controls: [
    'WASD / 방향키  이동',
    'Shift  달리기 (소리 큼)   Ctrl 또는 C  살금살금 (소리 작음)',
    '마우스  손전등 방향   F  손전등 켜기/끄기',
    'E  상호작용 (문 열기, 숨기, 줍기, 조사하기)',
    'Space  아이템 사용/던지기   Q / R 또는 휠  선택   G  떨어뜨리기',
    'C / Ctrl + G  조심히 내려놓기 · 카펫은 발소리를 줄여 준다',
    'Tab  조종할 친구 바꾸기',
    '1 따라와   2 대기   3 숨기 · 같은 층의 가까운 친구에게 신호',
    'M  지도   J  수첩   Esc  일시정지',
  ],
  touchControls: [
    '왼쪽 화면을 밀어 이동 · 살짝 밀면 살금살금, 끝까지 밀면 걷기',
    '달리기 버튼을 누르면 멈출 때까지 달린다 (소리 큼)',
    '오른쪽 화면을 밀어 손전등 방향 조준 · 손전등 버튼으로 켜고 끄기',
    '상호작용 버튼: 문 열기, 숨기, 줍기, 조사하기',
    '사용 버튼: 아이템 사용/던지기 · 아래 칸을 눌러 아이템 선택',
    '놓기 버튼을 길게 누르면 조심히 내려놓는다',
    '위쪽 얼굴을 누르면 그 친구를 조종한다',
    '따라와 / 대기 / 숨어: 같은 층의 가까운 친구에게 신호',
    '오른쪽 가장자리: 전체 화면 · 일시정지 · 지도 · 수첩',
    '아이폰은 공유 → 홈 화면에 추가로 실행해야 전체 화면이 된다',
  ],
  gaitName: { sneak: '살금살금', walk: '걷기', run: '달리기' } as Record<string, string>,
};
